export enum FacilityStatusType {
  active = 1,
  inactive = 2,
}
